import { z } from "zod";
import { ChatbotStyleSchema } from "../schema";

const StyleSchema = ChatbotStyleSchema.pick({
  height: true,
  heightValue: true,
});

export const buildBlockDisplayStyle = (
  opts: z.infer<typeof StyleSchema> & { isInPopup?: boolean }
) => {
  const DEFAULT_HEIGHTS = {
    maxHeight: "calc(100vh - 130px)",
    height: "initial",
  };

  if (opts.isInPopup) {
    return {
      maxHeight: "100%",
      height: "initial",
    };
  } else if (opts.height === "custom") {
    if (!opts.heightValue) {
      return DEFAULT_HEIGHTS;
    }

    return {
      maxHeight: `${opts.heightValue}px`,
      height: `${opts.heightValue}px`,
    };
  }

  return DEFAULT_HEIGHTS;
};
